<div class="card">
  <div class="card-header">
    Target Keywords
  </div>
  <div class="card-body">
    <div>
        <ul class="list-group">
          <ng-container *ngFor="let $data of selectedUrl.Keywords">
            <ng-container *ngTemplateOutlet="targetKeywords;context:{$context:$data}"></ng-container>
          </ng-container>
        </ul>
        <ng-template #targetKeywords let-$context="$context">
          <ng-container *ngIf="!($context.Area)">
            <li class="list-group-item">
              <span>{{$context.Keyword.Name}}</span>
            </li>
          </ng-container>
          <ng-container *ngIf="$context.Area">
            <ng-container *ngIf="$context.IsAreaFirst">
              <li class="list-group-item">
                <span>{{$context.Area.Name}}</span>
                &nbsp;
                <span>{{$context.Keyword.Name}}</span>
                <span style="margin-top: 0" class="help-block">
                  <small>{{$context.Area.Name ? 'Separate location displayed first' : 'No Location'}}</small>
                </span>
              </li>
            </ng-container>
            <ng-container *ngIf="!($context.IsAreaFirst)">
              <li class="list-group-item">
                <span>{{$context.Keyword.Name}}</span>
                &nbsp;
                <span>{{$context.Area.Name}}</span>
                <span style="margin-top: 0" class="help-block">
                  <small>{{$context.Area.Name ? 'Separate location displayed last' : 'No Location'}}</small>
                </span>
              </li>
            </ng-container>
          </ng-container>
        </ng-template>
    </div>
  </div>
</div>